"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _setVideoInputDevice = _interopRequireDefault(require("../meeting/setVideoInputDevice"));
var _setAudioInputDevice = _interopRequireDefault(require("../meeting/setAudioInputDevice"));
var _setAudioOutputDevice = _interopRequireDefault(require("../meeting/setAudioOutputDevice"));
var _setMultipleDesiredAttendeeMuteStatuses = _interopRequireDefault(require("../attendee/setMultipleDesiredAttendeeMuteStatuses"));
var _types = require("./types");
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function createLocalCamera(settings) {
  return function (dispatch, getState) {
    var videoInputDeviceId = settings.videoInputDeviceId,
      audioInputDeviceId = settings.audioInputDeviceId,
      audioOutputDeviceId = settings.audioOutputDeviceId;
    var _getState = getState(),
      attendeeResponse = _getState.meeting.attendeeResponse;

    // set camera/mic preferences
    videoInputDeviceId && dispatch((0, _setVideoInputDevice["default"])(videoInputDeviceId));
    audioInputDeviceId && dispatch((0, _setAudioInputDevice["default"])(audioInputDeviceId));
    dispatch((0, _setAudioOutputDevice["default"])(audioOutputDeviceId));
    var attendeeId = attendeeResponse.Attendee.AttendeeId;
    dispatch((0, _setMultipleDesiredAttendeeMuteStatuses["default"])({
      attendeeId: false
    }));
    return (0, _utils.actionCreator)(_types.CREATE_LOCAL_CAMERA, {
      attendeeId: attendeeId,
      isCameraOn: 'director'
    });
  };
}
var _default = exports["default"] = createLocalCamera;